module.exports = __webpack_public_path__ + "static/media/poireaux.488fa9e0.svg";